import { ReactNode } from "react";
import { useNeumorphicTheme } from "@/contexts/NeumorphicThemeContext";
import { cn } from "@/lib/utils";

interface NeumorphicCardProps {
  children: ReactNode;
  variant?: "raised" | "recessed" | "flat";
  className?: string;
  hover?: boolean;
}

const NeumorphicCard = ({ 
  children, 
  variant = "raised", 
  className = "",
  hover = true 
}: NeumorphicCardProps) => {
  let theme = "light";
  try {
    const themeContext = useNeumorphicTheme();
    theme = themeContext.theme;
  } catch {
    // Not within NeumorphicThemeProvider, use default
  }

  const getStyles = () => {
    if (theme === "dark") {
      switch (variant) {
        case "raised":
          return "bg-[#0f0f0f] text-white shadow-[16px_16px_32px_#000000,-16px_-16px_32px_#0d0d0d]";
        case "recessed":
          return "bg-[#0f0f0f] text-white shadow-[inset_8px_8px_16px_#000000,inset_-8px_-8px_16px_#0d0d0d]";
        case "flat":
          return "bg-[#0f0f0f] text-white";
      }
    } else {
      switch (variant) {
        case "raised":
          return "bg-[#f5f5f5] text-black shadow-[16px_16px_32px_#d8d8d8,-16px_-16px_32px_#fefefe]";
        case "recessed":
          return "bg-[#f0f0f0] text-black shadow-[inset_8px_8px_16px_#e0e0e0,inset_-8px_-8px_16px_#fefefe]";
        case "flat":
          return "bg-[#f5f5f5] text-black";
      }
    }
  };

  const hoverStyles = hover ? (
    theme === "dark"
      ? "hover:shadow-[20px_20px_40px_#000000,-20px_-20px_40px_#0d0d0d] hover:translate-y-[-2px]"
      : "hover:shadow-[20px_20px_40px_#d0d0d0,-20px_-20px_40px_#fefefe] hover:translate-y-[-2px]"
  ) : "";

  return (
    <div className={cn(
      "rounded-2xl transition-all duration-300",
      getStyles(),
      hover && variant === "raised" && hoverStyles,
      className
    )}>
      {children}
    </div>
  );
};

export default NeumorphicCard;
